// extracted by mini-css-extract-plugin
export default {"ValidateModal":"ValidateModal_ValidateModal__3bIME"};